import WizardAssetSlugs from '@/modules/AnswersWizard/constants/WizardAssetSlugs';

// Static asset paths for wizard images
const wizardImages: Record<string, string> = {
  [WizardAssetSlugs.HR_WIZARD_FINAL_OUTRO_IMAGE]:
    '/assets/contentful/4GqJ4fygr5WbMQ9GAjFSID.png',
};

// No-op for backward compatibility
async function fetchContentfulAssets() {
  // Static content loaded at import time
}

const getWizardImages = (key: string) => wizardImages[key] || '';

const useAnswersWizardAssets = () => {
  return {
    fetchContentfulAssets,
    getWizardImages,
  };
};

export default useAnswersWizardAssets;
